export type DeviceId = number & { __brand: 'DeviceId' }

export const DeviceIds = {
  None: 0x0 as DeviceId,

  IROKAl87: 0x258a00d4 as DeviceId,
  IROKAl87Rgb: 0x258a00e2 as DeviceId,
  IROKAl87Pro: 0x258a00bd as DeviceId,
  IROKFe75Pro: 0x258a00fc as DeviceId,
  IROKFe98Pro: 0x258a00fb as DeviceId,
  IROKHe2: 0x258a1007 as DeviceId,
  IROKHe3SE_Wireless_24g: 0x0c45c077 as DeviceId,
  IROKHe3SE_Wireless: 0x0c450500 as DeviceId,
  IROKMg87: 0x258a010c as DeviceId,

  IROKNA87: 0x304167372 as DeviceId,
  IROKNd75: 0x204167372 as DeviceId,
  IYXMu68: 0x104167372 as DeviceId,

  IROKNa87Pro: 0x201c4fee88 as DeviceId,
  IROKNd63: 0x301c4fee88 as DeviceId,
  IROKNd63_cyan: 0x311c4fee88 as DeviceId,

  IROKQMKLi75: 0x14806340 as DeviceId,
  IYXOp75: 0x258a018a as DeviceId,
  IYXTp87: 0x258a018b as DeviceId,
  IYXMt87: 0x258a01a6 as DeviceId,

  IYXMu68Pro: 0x101c4fee88 as DeviceId,
  IYXMu68Pro_cyan: 0x111c4fee88 as DeviceId,
  IYXMu68_ULTRA: 0x121c4fee88 as DeviceId,

  IYXPolar75: 0x401ca30201 as DeviceId,
  IYXAmber358_24g8k: 0x093a522c as DeviceId,
  IYXAmber358_Wired: 0x093a622c as DeviceId,

  CarotmasMars68Pro: 0x3031515029 as DeviceId,
  CarotmasMars68Pro_Wireless: 0x31515030 as DeviceId,
  CarotmasMars68Pro_Wireless_24g: 0x3151502b as DeviceId,

  CarotmasMars68: 0x2031515029 as DeviceId,
  CarotmasMars68SE: 0x1031515029 as DeviceId,

  CarotmasMars68_Wireless: 0x4031515030 as DeviceId,
  CarotmasMars68_Wireless_24g: 0x31515026 as DeviceId,

  MonsGeek: 0x3151502d as DeviceId,
  MonsGeek_NoLight: 0x3151502e as DeviceId,
  MonsGeek_NoLight_24g: 0x31514011 as DeviceId,

  IROKMg68: 0x103151502d as DeviceId,
  IROKMg68SE: 0x203151502d as DeviceId,
  IROKMg68Pro: 0x303151502d as DeviceId,
  IROKMg68LITE: 0x403151502d as DeviceId,

  IROKMg68Max: 0x3151502f as DeviceId,
  IROKMg68Max_24g: 0x103151502b as DeviceId,

  IROKMg75: 0x101ca50807 as DeviceId,
  IROKMg75PRO: 0x201ca50807 as DeviceId,

  CarotmasMer68: 0x101ca50806 as DeviceId,
  CarotmasMer68Pro: 0x111ca50806 as DeviceId,
  CarotmasMer68SE: 0x4031515029 as DeviceId,
  CarotmasMer68Lite: 0x4131515029 as DeviceId,
  CarotmasMer68Max: 0x1ca6052d as DeviceId,
  CarotmasMer68SE_JT: 0x1ca60540 as DeviceId,

  CarotmasMars75: 0x1ca6052b as DeviceId,
  CarotmasMars75Pro: 0x101ca6052b as DeviceId,

  He6Ultra: 0x3554fb36 as DeviceId,
  He6Ultra_24g: 0x3554fb35 as DeviceId,

  IROKMg68Plus: 0x1ca6052a as DeviceId,
  IROKMg75Max: 0x1ca60529 as DeviceId,

  IROKMG68ACE: 0x5031515029 as DeviceId,
  IROKMG68ACE_UpPlus: 0x5131515029 as DeviceId,
  IROKMG68ACE_W: 0x5131515030 as DeviceId,
  IROKMG68ACE_W_24g: 0x5231515038 as DeviceId,

  IROKND68Pro: 0x1ca6052c as DeviceId,
  IROKND63Ultra: 0x1ca60531 as DeviceId,

  IROKND68: 0x31515029 as DeviceId,
  IROKND63Max: 0x603151502d as DeviceId,

  IrokFe87V2: 0x19bf1020 as DeviceId,
  IrokFe87V2_24g: 0x1a868300 as DeviceId,
  IrokFe87V2IMC: 0x19bf1030 as DeviceId,
  IrokFe87V2IMC_24g: 0x101a868300 as DeviceId,
  IrokFe87V2C18: 0x1019bf1020 as DeviceId,

  CarotmasMer68SESelfDev: 0x19bf1010 as DeviceId,

  IROKRA68: 0x1ca60528 as DeviceId,

  IROKMG63: 0x2f813004 as DeviceId,
  IROKRA68_1: 0x2f813005 as DeviceId,
  IROKMG75V2C12: 0x2f813007 as DeviceId,
  IROKMG63V2: 0x19f55765 as DeviceId,

  IROKFE87V2_MuYan: 0x28e9320e as DeviceId,
} as const

export const DeviceGroups = {
  RoYuanMg68: [
    DeviceIds.IROKMg68Max_24g,
    DeviceIds.IROKMg68Max,
    DeviceIds.IROKMg68LITE,
    DeviceIds.IROKMg68Pro,
    DeviceIds.IROKMg68SE,
    DeviceIds.IROKMg68,
    DeviceIds.IROKMG68ACE,
    DeviceIds.IROKMG68ACE_UpPlus,
    DeviceIds.IROKMG68ACE_W,
    DeviceIds.IROKMG68ACE_W_24g,
  ],
  RoYuanMars68: [
    DeviceIds.CarotmasMars68Pro,
    DeviceIds.CarotmasMars68Pro_Wireless,
    DeviceIds.CarotmasMars68Pro_Wireless_24g,
    DeviceIds.CarotmasMars68,
    DeviceIds.CarotmasMars68SE,
    DeviceIds.CarotmasMars68_Wireless,
    DeviceIds.CarotmasMars68_Wireless_24g,
  ],
  RoYuanMonsGeek: [DeviceIds.MonsGeek, DeviceIds.MonsGeek_NoLight, DeviceIds.MonsGeek_NoLight_24g],
  RoYuanMer68: [DeviceIds.CarotmasMer68SE, DeviceIds.CarotmasMer68Lite],
  RoYuanND68: [DeviceIds.IROKND68],
  RoYuanND63: [DeviceIds.IROKND63Max],
  RoYuan24G: [DeviceIds.IROKMg68Max_24g, DeviceIds.CarotmasMars68Pro_Wireless_24g, DeviceIds.CarotmasMars68_Wireless_24g, DeviceIds.IROKMG68ACE_W_24g],

  JingTaiMg75: [DeviceIds.IROKMg75, DeviceIds.IROKMg75PRO],
  JingTaiMer68: [DeviceIds.CarotmasMer68, DeviceIds.CarotmasMer68Pro],
  JingTaiV1Base: [DeviceIds.IROKNa87Pro, DeviceIds.IYXMu68Pro, DeviceIds.IYXMu68Pro_cyan, DeviceIds.IYXMu68_ULTRA, DeviceIds.IROKNd63, DeviceIds.IROKNd63_cyan, DeviceIds.IYXPolar75],
  JingTaiV2: [
    DeviceIds.IROKMg68Plus,
    DeviceIds.IROKMg75Max,
    DeviceIds.CarotmasMars75,
    DeviceIds.CarotmasMars75Pro,
    DeviceIds.IROKND68Pro,
    DeviceIds.IROKND63Ultra,
    DeviceIds.CarotmasMer68Max,
    DeviceIds.CarotmasMer68SE_JT,
    DeviceIds.IROKRA68,
  ],

  HuoChaiRen: [DeviceIds.IROKMG63, DeviceIds.IROKRA68_1, DeviceIds.IROKMG75V2C12, DeviceIds.IROKMG63V2],
  HuoChaiRenUi: [DeviceIds.IROKMG63, DeviceIds.IROKRA68_1, DeviceIds.IROKMG75V2C12],
  ZhiHuiWuXian: [DeviceIds.IROKFE87V2_MuYan],

  He6Ultra: [DeviceIds.He6Ultra, DeviceIds.He6Ultra_24g],
  HE3SEMouse: [DeviceIds.IROKHe3SE_Wireless, DeviceIds.IROKHe3SE_Wireless_24g],
  Amber: [DeviceIds.IYXAmber358_24g8k, DeviceIds.IYXAmber358_Wired],
  HE2Mouse: [DeviceIds.IROKHe2],
  Witmod: [DeviceIds.IYXMu68, DeviceIds.IROKNd75, DeviceIds.IROKNA87],
  BeiYing: [DeviceIds.IROKAl87, DeviceIds.IROKAl87Pro, DeviceIds.IROKAl87Rgb, DeviceIds.IROKMg87, DeviceIds.IYXOp75, DeviceIds.IYXTp87, DeviceIds.IYXMt87, DeviceIds.IROKFe75Pro, DeviceIds.IROKFe98Pro],
  QMK: [DeviceIds.IROKQMKLi75],
  Fe87v2: [DeviceIds.IrokFe87V2, DeviceIds.IrokFe87V2_24g, DeviceIds.IrokFe87V2IMC, DeviceIds.IrokFe87V2IMC_24g, DeviceIds.IrokFe87V2C18],
  Fe87C18: [DeviceIds.IrokFe87V2C18],
  SelfDevMagnet: [DeviceIds.CarotmasMer68SESelfDev],
} as const

export const AllDeviceIds = Object.values(DeviceIds)
export const LegacyDeviceIdAliases: Record<number, DeviceId> = {
  0x401c4fee88: DeviceIds.IYXPolar75,
}

export const canonicalizeDeviceId = (value: number): DeviceId | undefined => {
  if (AllDeviceIds.includes(value as DeviceId)) return value as DeviceId
  return LegacyDeviceIdAliases[value]
}

export const isKnownDeviceId = (value: number): value is DeviceId => canonicalizeDeviceId(value) !== undefined
